module.exports = __webpack_public_path__ + "img/sinpe-iban.7685a531.png";